<div
    class="wizy-divider"
    [class.vertical]="vertical"
    [class.horizontal]="!vertical"
    [class.inset]="inset"
    [style.margin-top]="marginTop"
    [style.margin-bottom]="marginBottom"
    role="separator"
    [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
></div>
